export const initialState = () => ({
  uuid: null,
  isEditing: false,
  active: true,
  providerId: "",
  provider: {},
  name: "",
  cod: "",
  layout: {}
})
